import { LiveSearchMetadataController } from '../controller/LiveSearchMetadataController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { QueryExecution } from '../../types';

export class LiveSearchMetadataWebComponent extends BaseWebComponentElement {
  public controller: LiveSearchMetadataController;
  private queryExecution: QueryExecution | null = null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: LiveSearchMetadataController,
    });
  }

  public getQueryExecution(): QueryExecution | null {
    return this.queryExecution;
  }

  public setQueryExecution(queryExecution: QueryExecution | null): void {
    this.queryExecution = queryExecution;
    this.controller.render();
  }

  public unsetQueryExecution(): void {
    this.queryExecution = null;
    this.controller.render();
  }
}
